import React, { useState } from 'react';
import {
  FriendRequestAction,
  FriendRequestType,
  IFriendSuggestion,
  ISendFriendRequestPayload,
} from '../../types/friend';
import { Link } from 'react-router-dom';
import ButtonPrimary from '../button-refactor/button-primary';
import _size from 'lodash/size';
import NoData from '../no-data/no-data.component';
import Avatar from '../avatar/avatar.component';
import { userService } from '../../services/user.service';
import ButtonSecondary from '../button-refactor/button-secondary';
import { useFollow } from '../../hooks/useFollow/useFollow';

interface ListFriendSuggestionProps {
  data: IFriendSuggestion[];
  userId: string;
  onSuccess: () => void;
}

const ListFriendSuggestion = ({
  data,
  userId,
  onSuccess,
}: ListFriendSuggestionProps) => {
  const { handleFollow, handleUnFollow } = useFollow();

  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const handleAddFriend = async (payload: ISendFriendRequestPayload) => {
    try {
      setLoading(true);
      await userService.sendFriendRequest(payload);
      setSuccess(true);

      onSuccess();
    } catch (error) {
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const onAddFriend = async (user: IFriendSuggestion) => {
    const payload: ISendFriendRequestPayload = {
      requestUserId: userId,
      userId: user.requestUserId,
      statusAction: FriendRequestAction.SEND_REQUEST,
      typeRequest: FriendRequestType.FRIEND,
    };

    handleAddFriend(payload);
  };

  if (!_size(data)) {
    return (
      <div className="mt-16 mx-auto w-40">
        <NoData />
      </div>
    );
  }

  return (
    <>
      {data.map((item) => (
        <div key={item.requestUserId}>
          <div
            className="rounded-lg p-2 border border-[#DEE0E6] dark:border-slate-700 dark:bg-zinc-800
              transition-all flex  items-center gap-3 duration-200 hover:shadow-lg"
          >
            <Link to={`/user/${item.userName}`}>
              <img
                src={
                  item.avatar ||
                  '/default-avatar.svg'
                }
                alt="avatar"
                className="2xl:max-w-[120px] max-w-[76px] bg-white object-cover rounded-lg aspect-square"
              />
            </Link>

            <div className="flex flex-col w-full gap-[6px]">
              <Link to={`/user/${item.userName}`}>
                <h3 className="text-slate-800 truncate dark:text-slate-50 text-sm font-semibold max-w-full">
                  {item.requestFullName}
                </h3>
              </Link>

              <div className="  flex gap-2">
                <ButtonSecondary
                  className="w-fit  px-2 flex justify-center items-center py-1 !rounded !border-[#DEE0E6] dark:border-slate-700 font-semibold !text-xs"
                  onClick={async () => {
                    if (item.isFollow) {
                      await handleUnFollow(item.requestUserId);
                      onSuccess();
                    } else {
                      // onFollow(item.requestUserId);
                      await handleFollow(item.requestUserId);
                      onSuccess();
                    }
                  }}
                >
                  {item.isFollow ? 'Hủy theo dõi' : 'Theo dõi'}
                </ButtonSecondary>
                <ButtonPrimary
                  className="w-fit px-2 items-center justify-center !bg-[#0057FF] py-1 !rounded text-white !text-xs "
                  onClick={() => onAddFriend(item)}
                >
                  Kết bạn
                </ButtonPrimary>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ListFriendSuggestion;
